import produce from 'immer';

// TYPES
import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarPerfis } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ConsultarPerfis = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarPerfis {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_PERFIS_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CONSULTAR_PERFIS_SUCCESS: {
				draft.enum = toSelect(action.payload.data, 'descricao', 'id');
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];
				break;
			}

			case Types.CONSULTAR_PERFIS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_PERFIS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
